<template>
<div class="login-container" :class="lang">
  <div class="login-wrapper">
    <section class="login-content">
      <h1 class="mb-3">{{$t('signup.signup')}}</h1>
      <!-- errors -->
      <div v-if="message">
        <div class="alert">
          <button type="button" v-on:click="resetResponse" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button> {{message}}
        </div>
      </div>
      <div v-if="error">
        <div class="alert">
          <button type="button" v-on:click="clearError" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button> {{error}}
        </div>
      </div>
      
      <!-- フォーム部分 -->
      <v-form ref="signupForm">
      
        <v-text-field :label="$t('user-params.username')" v-model="username"
          :rules="validate.usernameRules($t)"
          color="white"
          required>
        </v-text-field>
<!--        
        <v-text-field :label="$t('user-params.password')" v-model="password"
          :rules="validate.passwordRules($t)" type="password"
          color="white"
          :append-icon="passwordVisible? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (passwordVisible = !passwordVisible)"
          :type="passwordVisible ? 'text':'password'"
          required autocomplete="password">
        </v-text-field>
        
        <v-text-field :label="$t('user-params.password_reinput')" v-model="password_reinput"
          :rules="validate.passwordReinputRules($t, password)" type="password"
          color="white"
          :append-icon="passwordVisible? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (passwordVisible = !passwordVisible)"
          :type="passwordVisible ? 'text':'password'"
          required autocomplete="password">
        </v-text-field>
-->
        <v-text-field :label="$t('user-params.email')" v-model="useremail"
          :rules="validate.emailRules($t)" 
          color="white"
          required autocomplete="email">
        </v-text-field>

        <!-- EULA -->
        <v-card flat class="mt-4 ma-1 pa-3 body-2 grey black--text">
          <div v-html="$t('signup.agreement_msg')" id="EULA"></div>
        </v-card>
        <!-- ラベルの末尾に '*' が付くと変なので required なし -->
        <v-checkbox :label="$t('activate.agree')" v-model="agree"
          :rules="checkboxRules"
          class="agree_checkbox mt-3">
        </v-checkbox>
        
        <v-btn color="blue" dark @click="checkCreds"
          :class="!agree || done ? 'grey lighten-1' : 'blue'" 
          :disabled="!agree || done">
            {{done ? $t('signup.btn_check_email') : $t('signup.register')}}
        </v-btn>
        <p/>
        
        <!-- mailto:harps-support@aplix.co.jp 
          http://2tap.com/javascript-percent-encoder/
          "mailto:" をエンコードしてしまうとブラウザが認識しない。
          HTML実態参照では mailto: 以降だけ encode してもブラウザが認識しない
          https://www.beabridge.io/ の contactUs が mailto もエンコードしても動いているのは
          ランタイムの js が decode して DOM 生成しているから。
          -->
        <a href="mailto:%68%61%72%70%73%2d%73%75%70%70%6f%72%74%40%61%70%6c%69%78%2e%63%6f%2e%6a%70">
          {{$t('signup.buy_iotizr')}}
        </a>
        
      </v-form>
      
      <v-dialog v-model="confirmDialog" max-width="350">
        <v-card>
          <!-- <v-card-title class="headline">...</v-card-title>-->
          <v-card-text>{{$t("signup.signupConfirmDialogText")}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat="flat"
              @click.native="confirmDialog = false">Cancel</v-btn>
            <v-btn color="primary" flat="flat"
              @click.native="confirmDialog = false; window.grecaptcha.execute();"
              >Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="okDialog" persistent max-width="350">
        <v-card>
          <v-card-text>
            <div id="OKDIALOG" v-html="$t('signup.signupSuccessDialogText')"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat="flat" v-on:click="signUpCompleted()">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="errorDialog" persistent max-width="350">
        <v-card>
          <v-card-text v-html="errorDialogMessage"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat="flat" v-on:click="errorDialog=false">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="g-recaptcha" data-size="invisible"></div>

    </section>
    <login-footer/>
  </div>
</div>
</template>

<script>
/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */

import validate from '@/utils/validate.js'
//import axios from 'axios'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import LoginFooter from '@/pages/LoginFooter'

export default {
  name: 'login',
  components: {
    LoginFooter
  },
  data () {
    return {
      username: '',
//      password: '',
//      password_reinput: '',
      useremail: '',
      response: '',
      error: '',
      name: '',
//      passwordVisible: false,
      agree: false,
      checkboxRules: [
        (v) => !!v || this.$t('activate.you_need_to_agree')
      ],
      done: false,
      
      confirmDialog: false,
      okDialog: false,
      errorDialog: false,
      errorDialogMessage: "",

      sitekey: "",
      
      lang: navigator.language || navigator.userLanguage,
      window: window,
      validate: validate,
    }
  },
  beforeMount(){
    let ip = location.hostname.split('.')
    if (location.hostname.indexOf('localhost') == 0 || 
        location.hostname.indexOf('stage-') == 0 ||
        (ip.length == 4 && ip[0] == 172 && 16 <= ip[1] && ip[1] <= 31))
    {
      console.log('use sitekey for localhost')
      this.sitekey = "6LfVd2gUAAAAAP_cqo5YLUfv3vB9ylQiMy8_hBmu"
    }else{
      // production
      this.sitekey = "6LfwEjkUAAAAAKSzEQWsaxxbT-7erZ3Yc4FWDdTC"
    }
  },
  mounted(){
    if (!utils.isHarps4()){
      this.$router.push({
        name: 'Page404'
      })
      return
    }
  
    // https://maketips.net/tip/61/example-integrate-recaptcha-with-vuejs
    let retry = 50
    let func = () => {
      if (!window.grecaptcha.render){
        if (retry-- <= 0){
          console.error('grecaptcha init wait failed')
        }else{
          console.log('retry')
          setTimeout(func, 0)
        }
        return
      }
      let div_grecaptcha = $('.g-recaptcha')[0]
      window.grecaptcha.render(div_grecaptcha, {
        sitekey : this.sitekey,
        callback : this.submit, 
        'error-callback' : this.g_recaptchaError
      })
    }
    setTimeout(func, 0)
  },
  computed: {
    message () {
      if (this.$store.getters.message !== null) {
        this.response = this.$store.getters.message.message
        this.$store.commit('SET_MESSAGE', null)
      }
      return this.response
    }
  },
  methods: {
    checkCreds () {
      console.log('checkCreds')

      // validation
      let valid = this.$refs.signupForm.validate()
      if (!valid){
        const errors = this.$refs.signupForm.getInputs().filter(
                                  input => input.errorBucket.length)
        let errorMsg = ""
        for (let validErrMsgs of errors) {
          errorMsg += (validErrMsgs.errorBucket[0] + "\n")
        }
        alert(errorMsg)
        return
      }
      
      this.username = this.username.trim()
      this.resetResponse()
      this.clearError()

      this.confirmDialog = true
    },
    
    submit(g_recaptcha_response){
      //console.log('submit ' + JSON.stringify(g_recaptcha_response))
      // reset しないと、一度 execute した widget は再度 execute しても何もしなくなる。
      window.grecaptcha.reset()
      
      this.signUp(g_recaptcha_response)
    },
    
    g_recaptchaError(){
      console.log('g_recaptchaError')
    },
    
    resetResponse () {
      this.response = ''
    },
    
    clearError () {
      this.error = ''
    },
    
    signUp(g_recaptcha_response){
      const params = {
        username: this.username,
        useremail: this.useremail,
        g_recaptcha_response: g_recaptcha_response
      }
      http.request('post', '/service2/dashboard/api/organizations/signup', params)
//      axios({
//        method: 'post', 
//        url: '/service/dashboard/api/organizations/signup', 
//        data: params})
      .then(response => {
        //console.log('then(response => ' + JSON.stringify(response) + ')')
        const data = response.data
        if (data.result !== 0) {
          let errstr = JSON.stringify(response)
          console.error(errstr)
          switch (data.result) {
            case -102:
              if (data.rawcode){
                this.showErrorDialog(this.$t('cognitoError.' + data.rawcode))
              }else{
                this.showErrorDialog(this.$t('cognitoError.UnknownError'))
              }
              break
            case -33:
              this.showErrorDialog(
                  this.$t('account.vali-username-format') + '\n' + 
                  this.$t('account.vali-username-char'))
              break
            default:
              this.showErrorDialog(this.$t('cognitoError.UnknownError') + 
                  '\n(' + errstr + ')')
          }
        } else {
          // success
          this.done = true
          this.okDialog = true
        }
        
      }).catch((err) => {
        const errstr = JSON.stringify(err)
        console.log('catch(err) ' + errstr)
        // 想定外の場合は raw メッセージを出す
        this.showErrorDialog(this.$t('cognitoError.UnknownError') + 
            '\n(' + errstr + ')')
      })
    }, // signUp()
    
    signUpCompleted(){
      this.okDialog = false
//      this.$router.push({
//        name: 'Login'
//      })
    },
    
    showErrorDialog(message){
      this.errorDialogMessage = message.replace('\n', '<br>')
      this.errorDialog = true
    }
  }
}
</script>

<style>
/* ログイン時にくるくるが見えにくいので修正 */

.pace .pace-progress {
  background-color: #FFD54A;
  height: 3px;
}

.pace .pace-progress-inner {
  box-shadow: 0 0 10px #FFD54A, 0 0 5px #FFD54A;
}

.pace .pace-activity {
  border-top-color: #FFD54A;
  border-left-color: #FFD54A;
}

.agree_checkbox label{
  height: auto; /* 横幅に収まらないときに縦を広げる */
  white-space: normal; /* 改行させる */
  max-width: 100% !important; /* 右側に空間があくのを防ぐ */
  margin: 5px !important; /* input-group--focused で margin 0 がセットされるのを防ぐ */
}
.agree_checkbox .icon{
  /* checkbox とラベルの縦位置がずれるのを調整 */
  margin-top: 0.3em !important;
}
.agree_checkbox{
  width: 100% !important;
}
.agree_checkbox .input-group__details{
  /* "You need to agree" をラベルの下に位置するため */
  margin-top: 2em;
}
.agree_checkbox .input-group__error {
  color: red !important;
}
#EULA, #OKDIALOG {
  text-align: left;
}
#EULA ul{
  list-style-type: disc; 
  margin-left: 1.5em;  
}
</style>

<style scoped>
/* EULA の位置調整。Activate.vue と同じ */
.login-content {
  padding-top: 20px;
}
.login-wrapper{
  overflow-y: scroll;
}
.login-bottom {
  margin-top: 80px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// Signup.vue?4e5f4564